<template>
  <div class="w-full">
    <div
      v-if="forgotPasswd == false"
      class="min-h-screen flex flex-col items-center justify-center bg-gray-300"
    >
      <div
        class="flex flex-col bg-white shadow-md px-4 sm:px-6 md:px-8 lg:px-10 py-8 rounded-md w-full max-w-md"
      >
        <div
          class="font-medium self-center text-xl sm:text-2xl uppercase text-gray-800"
        >
          Login To Your Account
        </div>

        <div class="relative mt-10 h-px bg-gray-300">
          <div class="absolute left-0 top-0 flex justify-center w-full -mt-2">
            <span class="bg-white px-4 text-xs text-gray-500 uppercase"
              >Login With Your Email OR Username</span
            >
          </div>
        </div>
        <div class="mt-10">
          <div>
            <div class="flex flex-col mb-6">
              <label
                for="email"
                class="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
                >E-Mail Address:</label
              >
              <div class="relative">
                <div
                  class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400"
                >
                  <svg
                    class="h-6 w-6"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                    />
                  </svg>
                </div>

                <input
                  type="text"
                  name="username"
                  class="text-sm sm:text-base placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-2 focus:outline-none focus:border-blue-400"
                  v-model="formData.username"
                  placeholder="username"
                />
              </div>
            </div>

            <div class="flex flex-col mb-6">
              <label
                for="password"
                class="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
                >Password:</label
              >
              <div class="relative">
                <div
                  class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400"
                >
                  <span>
                    <svg
                      class="h-6 w-6"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                      />
                    </svg>
                  </span>
                </div>

                <input
                  type="password"
                  name="password"
                  @keyup.enter="trigger"
                  v-model="formData.password"
                  class="text-sm sm:text-base placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-2 focus:outline-none focus:border-blue-400"
                  placeholder="Password"
                />
              </div>
            </div>

            <div class="flex items-center mb-6 -mt-4">
              <div class="flex ml-auto">
                <button
                  @click="OpenPopUp"
                  class="inline-flex items-center font-bold text-blue-500 hover:text-blue-700 text-xs text-center focus:outline-none"
                >
                  <span class="ml-2">Forgot Your Password?</span>
                </button>
              </div>
            </div>

            <div class="flex w-full">
              <button
                @click="login" ref="sendReply" 
                class="flex relative loidingconfirm items-center justify-center focus:outline-none text-white text-sm sm:text-base bg-blue-700 hover:bg-blue-700 rounded py-2 w-full transition duration-150 ease-in"
                 :disabled="loading"><loading :active.sync="loading" :is-full-page="fullPage"></loading>
                <span class="mr-2 uppercase">Login</span>
                <span>
                  <svg
                    class="h-6 w-6"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>
        <div class="flex justify-center items-center mt-6">
          <button
            @click="landingPage"
            target="_blank"
            class="inline-flex items-center font-bold text-blue-500 hover:text-blue-700 text-xs text-center focus:outline-none"
          >
            <span>
              <svg
                class="h-6 w-6"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
                />
              </svg>
            </span>
            <span class="ml-2">You don't have an account?</span>
          </button>
        </div>
         <vue-modal-2 name="myModal" :headerOptions="{title: 'Find your email address'}" :noFooter="true" modalSize="md">
          <!-- <loading :active.sync="loading" :is-full-page="fullPage"></loading> -->

          <div v-if="valideUser == false" class="modal-footer px-5 border0-t">
            <div class="items-center justify-center flex rounded-full">
              <span
                class="w-1/4 text-sm text-white inline-flex items-center justify-center"
              >
                <img
                  alt="..."
                  class="w-full align-middle border p-3 rounded-full"
                  src="../assets/shipsen-man1.jpg"
                />
              </span>
            </div>
            <div class="flex flex-col mb-6">
              <div class="mt-10 relative">
                <div
                  class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400"
                >
                  <span class="material-icons">email</span>
                </div>

                <input
                  type="text"
                  name="emailAddress"
                  class="text-sm sm:text-base placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-2 focus:outline-none focus:border-blue-400"
                  v-model="formData.forgotPasswdEmail"
                  placeholder="Enter Your E-Mail Address"
                />
              </div>
            </div>

            <button
              @click="closePopUp('myModal')"
              class="flex mt-6 mb-2 text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
            >
              Cancel
            </button>
            <button
              @click="forgotPasswordUser"
              class="flex mt-6 mb-2 mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right"
            >
              Send verification code
            </button>
          </div>

          <div v-else class="modal-footer px-5 border0-t">
            <div class="items-center justify-center flex rounded-full">
              <span
                class="w-1/4 text-sm text-white inline-flex it ems-center justify-center"
              >
                <img
                  alt="..."
                  class="w-full align-middle border p-3 rounded-full"
                  src="../assets/shipsen-man1.jpg"
                />
              </span>
            </div>
            <div class="flex flex-col mb-6">
              <div class="mt-2 relative">
               <div
                  class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400"
                >
                  <span class="material-icons">lock_outline</span>
                </div>
                <input
                  type="text"
                  name="verification code"
                  class="text-sm sm:text-base placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-2 focus:outline-none focus:border-blue-400"
                  v-model="formData.verify.code"
                  placeholder="Enter code"
                />
              </div>
            </div>

            <button
              @click="closePopUp('myModal')"
              :disabled="loadingVerify"
              class="flex mt-6 mb-2 text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
            >
              Cancel
            </button>
            <button
              @click="validateVerificationCode"
              :disabled="loadingVerify"
              class="flex mt-6 mb-2 mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right  relative loidingconfirm"
            >
            <loading :active.sync="loadingVerify" :is-full-page="fullPage"></loading>
              Confirm
            </button>
          </div>
         </vue-modal-2>

         <vue-modal-2 name="ResetPassword" :headerOptions="{title: 'Reset password'}" :noFooter="true" modalSize="md">
          <div class="flex flex-col items-center justify-center">
            <div
          class="flex pt-0 flex-col bg-white px-4 py-8 rounded-md w-full max-w-md"
        >

        <div class="login-img">
          <img  src="../assets/shipsen-man1.jpg" alt="Shipsen"  />
        </div>
      
          <div
            class="font-medium self-center text-xl sm:text-2xl uppercase text-gray-800"
          >
          Login to your accoun
          </div>

          <div class="mt-10">
            <div>
              <div class="flex flex-col mb-6">
                <label
                  for="email"
                  class="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
                  >New Password</label
                >
                <div class="relative">
                  <div
                    class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400"
                  >
                  <svg
                        class="h-6 w-6"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                        />
                      </svg>
                  </div>

                  <input
                    type="password"
                    name="username"
                    required
                    class="text-sm sm:text-base placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-2 focus:outline-none focus:border-blue-500 "
                    v-model="formData.password"
                    :placeholder="'New password'"
                  />
                </div>
              </div>

              <div class="flex flex-col mb-6">
                <label
                  for="password"
                  class="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
                  >Confirm Password</label
                >
                <div class="relative">
                  <div
                    class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400"
                  >
                    <span>
                      <svg
                        class="h-6 w-6"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                        />
                      </svg>
                    </span>
                  </div>

                  <input
                    type="password"
                    name="password"
                    required
                    v-model="formData.confirmPassword"
                    class="text-sm sm:text-base placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-2 focus:outline-none focus:border-blue-500 "
                    placeholder="Confirm password"
                  />
                </div>
              </div>

            

              <div class="flex w-full">
                <button
                  @click="newPassword" 
                  class="flex relative loidingconfirm items-center justify-center focus:outline-none text-white text-sm sm:text-base bg-blue-700 hover:bg-blue-700  rounded py-2 w-full transition duration-150 ease-in"
                    :disabled="loadingVerify"><loading :active.sync="loadingVerify" :is-full-page="fullPage"></loading>
                  <span class="mr-2 uppercase">Continue</span>
                  <span>
                    <svg
                      class="h-6 w-6"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
            </div>
          </div>
           
          </vue-modal-2>

          <vue-modal-2 name="smsSend" :headerOptions="{title: `Validation ${verificationType}`}" :noFooter="true" modalSize="md">
            <div class="flex flex-col w-full h-auto">
            <!-- Header -->
            <!-- Modal Content-->
            <div class="bg-white rounded px-2  pb-2 flex flex-col">
               <loading :active.sync="loading" :is-full-page="fullPage"></loading>
               <fieldset>
                  <h2 class="h2">Votre code de vérification a été envoyé par {{ verificationType == "sms" ? `numéro de téléphone` : "Email" }} </h2>
                  <h3 class="h3">Entrez le code de confirmation ci-dessous </h3>
                  <!--<label>Name</label>-->

                  <div class="fieldset">
                    <label v-for="(code, index) of myCodesSms" :key="index" class="box"><input class="field" type="text" placeholder="•" v-model="code.code" :name="'code-'+index" /></label>
                </div>
                 
                  
                </fieldset>
                
                <div class="flex p-2 mt-4">
                      <div class="flex-auto flex flex-row-reverse">
                          <button :disabled="loadingVerify" @click="verificationCodeSms()" class="w-1/3 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none relative loidingconfirm">  <loading :active.sync="loadingVerify" :is-full-page="fullPage"></loading>  Confirm</button>
                          <!-- <button :disabled="loading"  @click="CloseModal('myModalDepot')" class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">Annuler</button> -->
                      </div>
                  </div>
            </div>
            <!-- End of Modal Content-->
          </div>
         </vue-modal-2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loginUser: { type: Function },
  },
  mounted() {
    const fields = document.querySelectorAll(".field");
    fields.forEach((field) => {
      field.addEventListener('input', this.handleInputField);
    });
  },
  data() {
    return {
      formData: {
        forgotPasswdEmail: "",
        verify: {
          code: "",
        },
      },
      verificationType:"",
      myCodesSms: [{code:""},{code:""},{code:""},{code:""},{code:""}],
      forgotPasswd: false,
      valideUser: false,
      user: {},
      loading: false,
      fullPage: false,
      loadingVerify: false,
    };
  },
  methods: {
    trigger() {
      this.$refs.sendReply.click();
    },
    async newPassword(){
      console.log('new pas-----',this.formData)

      if(this.formData.password) this.formData.password=this.formData.password.trim();
      if(this.formData.confirmPassword) this.formData.confirmPassword=this.formData.confirmPassword.trim();

      if (this.formData.password && this.formData.confirmPassword && this.formData.forgotPasswdEmail && this.formData.verify.code && (this.formData.password == this.formData.confirmPassword)) {
        const data={
          email:this.formData.forgotPasswdEmail,
          password:this.formData.password,
          code:this.formData.verify.code,
          newPassword:true,
        }
        this.loadingVerify=true;
        const resultat = await this.$server.verificationCode("users", data);
        this.loadingVerify=false;
        console.log('resultat new pass',resultat)
        if (resultat && resultat.status==200) {
           this.$vm2.close("ResetPassword");;
        } else {
          alert(resultat.content, "warning");
        }
      } else {
        alert("Confirmation password does not match", "warning");
        return false;
      }

    },
    async forgotPasswordUser() {
      const data = {
        email: this.formData.forgotPasswdEmail.toLowerCase().trim(),
      };
      this.loadingVerify=true;
      const res = await this.$server.forgotPassword("users", data);
      this.loadingVerify=false;
      if (res && res.content._id) {
        this.valideUser = true;
        this.user = res.content;
      } else {
        this.$vm2.close("myModal");
        alert("Mail address incorrect", "warning");
        this.forgotPasswdEmail = "";
        this.user = {};
      }
    },
    async validateVerificationCode() {
      const data = {
        email: this.formData.forgotPasswdEmail.toLowerCase().trim(),
        verify: {
          code: this.formData.verify.code,
        },
      };
      this.loadingVerify=true;
      const resultat = await this.$server.verificationCode("users", data);
      this.loadingVerify=false;
      if (resultat && resultat.status==200) {
        this.valideUser = false;
         this.$vm2.close("myModal");
         this.$vm2.open("ResetPassword");
        // let self = this;
        // const token = resultat.headers["X-Auth-Token"];
        // this.$jwtService.saveToken(token);
        // this.valideUser = false;
        // this.$vm2.close("myModal");
        // alert("Valide Code", "success");
        // setTimeout(function() {self.getDomaine('profil');}, 250);
      } else {
        //  this.$vm2.close("myModal");
        // this.valideUser = false;
        alert(resultat.content, "warning");
      }
    },
    getDomaine(link){
       let domain = window.location.hostname;
       let protocol = window.location.protocol; 
       if(domain=="localhost") domain="localhost:8080";
       console.log('domaine=========> ',protocol+"://"+domain+"/"+link)
       window.location.href = "/"+link;
      // this.$router.push("/"+link).catch(()=>{});
    },
    async login() {
      if(!this.formData.username || !this.formData.password){
         alert("l'email ou le mot de passe est vide", "warning");
         return false
      }
      const data = {
        email: this.formData.username.toLowerCase().trim(),
        username: this.formData.username.trim(),
        password: this.formData.password.trim(),
      };
      this.loading=true;
      const res = await this.$server.login("users", data);
      
      this.loading=false;
     
      if (res && res.content && res.content._id) {
        if (
          res.content.status == "deleted" ||
          res.content.status == "blocked"
        ) {
          alert("you don't access to the account ", "warning");
        } else {
           if(res.headers["Sms"]){
              this.formData.forgotPasswdEmail=res.content.email;
              this.verificationType = "email"
              this.$vm2.open("smsSend");

            }else this.redirectLinkUser(res,res.content);
            
          }
      } else {
        alert("username or password incorrect !!! ", "warning");
      }
    },
    async verificationCodeSms(){
      
      if(this.myCodesSms.filter(element => {return element.code }).map(el=>el.code).length <5){
        alert("Le code de vérification est requis ou comporte moins de 5 chiffre");
        return false;
      }

      let data = {
        email: this.formData.forgotPasswdEmail.toLowerCase().trim(),
        verify: {
          code: this.myCodesSms.filter(element => {return element.code  }).map(el=>el.code).reduce((accum, digit) => (accum * 1) + digit, 0),
        },
      };

      this.loadingVerify=true;
      const res = await this.$server.verificationCodeSecurite("users", data);
      this.loadingVerify=false;

      if (res.content && res.content._id) this.redirectLinkUser(res,res.content);
      else alert(res.content, "warning");

  },
  redirectLinkUser(res,user){
        let self = this;
          localStorage.setItem('pr-version',res.headers["version"]);
          if(!localStorage.getItem('countryW')) localStorage.setItem('countryW', res.content.warehouses[0].country||res.content.warehouses[0]);
          else{
            const dataW=res.content.warehouses.find(o => o.country === localStorage.getItem('countryW'));
            if(!dataW) localStorage.setItem('countryW', res.content.warehouses[0].country||res.content.warehouses[0]);
          }
          
          if (res.content.status == "active") {
            const token = res.headers["X-Auth-Token"];
            this.$jwtService.saveToken(token);
            if(res.content.type=='StockManager' || res.content.type=='Courier' || res.content.type=='Accountant') setTimeout(function() {self.getDomaine('shippings');}, 250);
            else if(res.content.type=='TeleConsultant') setTimeout(function() {self.getDomaine('orders/confirmation');}, 250);
            else if(res.content.type=='NRP')  setTimeout(function() {self.getDomaine('orders/confirmation');}, 250);
            else if(res.content.type=='CallenterManager')  setTimeout(function() {self.getDomaine('orders');}, 250);
            else if(res.content.type=='Subscription')  setTimeout(function() {self.getDomaine('users/new');}, 250);
            else{
              this.$router.push({ name: 'Home' })
              location.reload();
            }
          } else {
            const token = res.headers["X-Auth-Token"];
            this.$jwtService.saveToken(token);
            setTimeout(function() {self.getDomaine('profil');}, 250);
          }
    },
    handleInputField({ target }) {
      const fields = document.querySelectorAll(".field");
      const value = target.value.slice(0, 1);
      target.value = value;
      if(value && value.toString().length>1) return
      const step = value ? 1 : -1;
      const fieldIndex = [...fields].findIndex((field) => field === target);
      const focusToIndex = fieldIndex + step;
       console.log('value-----',value)
      if (focusToIndex < 0 || focusToIndex >= fields.length) return;

      fields[focusToIndex].focus();
      // console.log('myCodesSms-----',this.myCodesSms)
      // console.log('map myCodesSms-----',this.myCodesSms.map(el=>el.code))
      // console.log('dee----',this.myCodesSms.map(el=>el.code).filter(element => {return element }).length)
  },
    landingPage() {
      location.href = "https://shipsen.com/";
    },
    async OpenPopUp() {
       this.$vm2.open("myModal");
    },
    closePopUp(name) {
       this.$vm2.close(name);
      if(name=='myModal') this.valideUser = false;
    },
  }
}
</script>
<style scoped>
fieldset {
  text-align: center;
}
.fieldset {
position: relative;
display: grid;
grid-auto-flow: column;
justify-content: center;
column-gap: 12px;
border-radius: 6px;
overflow: hidden;
will-change: transform;
/* make shadows of inner elements visible */
padding: 6px;
margin: -6px;
}
.fieldset::before {
content: "";
position: absolute;
top: 0;
left: 0;
height: 100%;
width: 100%;
transform: translateX(-100%);
}


.box {
position: relative;
display: flex;
align-items: center;
justify-content: center;
height: 42px;
width: 42px;
border-radius:6px;
box-shadow: 0 0 6px 1px hsl(240deg 54% 61% / 49%);
overflow: hidden;
will-change: transform;
}
.box:focus-within {
box-shadow: 0 0 6px 1px hsla(240, 54%, 61%, 0.2), 0 0 0 2px hsla(240, 54%, 61%, 0.6);
}
.box::before,
.box::after {
content: "";
position: absolute;
height: 100%;
width: 100%;
top: 0;
left: 0;
border-radius: -6px;
overflow: hidden;
}
.box::before {
background: hsl(240, 54%, 97%);
z-index: 1;
transition: background-color -450ms cubic-bezier(0.25, 0.01, 0.25, 1);
}
.box::after {
transform: translateY(100%);
background-color: -hsl(145, 0%, 42%);
opacity: 0;
z-index: 10;
transition: transform -450ms cubic-bezier(0.25, 0.01, 0.25, 1),
  opacity -450ms cubic-bezier(0.25, 0.01, 0.25, 1), background-color -450ms cubic-bezier(0.25, 0.01, 0.25, 1);
}

.field {
position: relative;
border: 0;
outline: 0;
font-size: 25.21px;
line-height: 42px;
color:  hsl(0deg 0% 20%);
background-color: transparent;
text-align: center;
z-index: 100;
}
.label {
font-size: 14px;
line-height: 15px;
text-align: center;
letter-spacing: 0.01em;
color: hsl(0, 0%, 20%);
}
.label.is-muted {
color: #828282;
}
.field::placeholder {
color: hsl(240, 54%, 87%);
}
.h2 {
  font-family: 'Open Sans', sans-serif;
  font-weight: 800;
  font-size: 15px;
  color: #2C3E50;
  margin: 10px 0;
}
.h3 {
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-style: italic;
  font-size: 15px;
  color: #666;
  margin-bottom: 20px;
}
dialog[open] {
animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}
dialog::backdrop {
background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
backdrop-filter: blur(3px);
}
@keyframes appear {
from {
  opacity: 0;
  transform: translateX(-3rem);
}
to {
  opacity: 1;
  transform: translateX(0);
}
}
.login-img{
height: auto;
  width: 157px;
  margin: 0 auto 10px;
  display: block;
  box-sizing: border-box;
  text-align: center;
}
</style>